import React from 'react';
import type { ParserRule, ReactOutputRule } from 'simple-markdown';
import { defaultRules } from 'simple-markdown';

/**
 * A custom `SimpleMarkdown` `url` rule that processes plain URLs
 * Converts plain URLs like www.example.com or example.com to clickable links
 * Automatically adds https:// protocol when missing
 * @returns A `SimpleMarkdown` `url` rule
 */
export const buildUrl = () => {
  return {
    order: defaultRules.text?.order ? defaultRules.text.order - 0.5 : 0.5,
    match: (source: string) => {
      // Don't match if it starts with @ or contains @ before domain (email)
      if (/^@/.test(source) || /@[\w.-]*$/.test(source.split(/\s/)[0])) {
        return null;
      }
      // Match URLs: www.example.com, example.com, https://example.com
      return /^((?:https?:\/\/)?(?:www\.)?[\w-]+(?:\.[\w-]+)+(?:\/[^\s]*)?)/.exec(
        source
      );
    },
    parse: (capture: RegExpExecArray) => ({
      type: 'url',
      content: capture[1],
      target: capture[1],
    }),
    react: (node: any, _output: any, state: any) => {
      // Ensure URL has protocol
      const href = /^https?:\/\//i.test(node.target)
        ? node.target
        : `https://${node.target}`;

      return (
        <a
          key={state.key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => window.open(href)}
        >
          {node.target}
        </a>
      );
    },
  } as ParserRule & ReactOutputRule;
};
